export default "__VITE_ASSET__1b9a0427__"